module.exports = __webpack_public_path__ + "static/media/add-message.2a2582d7.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/add-message.svg
// module id = 1983
// module chunks = 0